// Utilities
import { formatPhoneNumber } from "../../../services/global.services";

// State management
import { useAppSelector } from "../../../services/StoreHelper";

// Styles
import email_styles from "./email_styles";

function EmailHeader() {
  // Redux state
  const { app_dimensions, club } = useAppSelector((state) => state.app);

  // Dynamic styles
  const styles = email_styles(app_dimensions);

  return (
    <div style={styles.header}>
      <h2 style={styles.title}>{club.name}</h2>
      <h4 style={styles.subtitle}>
        {club.street} • {club.city}, {club.state} {club.zip} •{" "}
        {formatPhoneNumber(club.phone)}
      </h4>
    </div>
  );
}

export default EmailHeader;